import React from 'react';
import { IconButton, Tooltip, alpha, useTheme } from '@mui/material';
import { AgencyIcon } from './AgencyIcon';

interface MonitoredAgencyIconProps {
  agencyLabel?: string | null;
  variant?: 'button' | 'icon';
  stopPropagation?: boolean;
}

/** Ícone de agência monitorada na coluna Ações (distinto do olho de norma/assunto). */
export function MonitoredAgencyIcon({
  agencyLabel,
  variant = 'button',
  stopPropagation = false,
}: MonitoredAgencyIconProps) {
  const theme = useTheme();
  const title = agencyLabel ? `Agência monitorada: ${agencyLabel}` : 'Agência monitorada';

  if (variant === 'icon') {
    return (
      <Tooltip title={title} arrow>
        <AgencyIcon fontSize="small" sx={{ color: 'primary.main' }} />
      </Tooltip>
    );
  }

  return (
    <Tooltip title={title} arrow>
      <IconButton
        size="small"
        color="primary"
        onClick={stopPropagation ? (event) => event.stopPropagation() : undefined}
        sx={{
          bgcolor: alpha(theme.palette.primary.main, 0.1),
          '&:hover': { bgcolor: alpha(theme.palette.primary.main, 0.18) },
        }}
      >
        <AgencyIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
}
